import moment from 'moment';

import { combineMomentDateTime } from '../../../helpers';

import type { Moment } from 'moment';
import type { IClientAssignment } from '../../../utils/types';

export function getSessionStartDateTime(sessionStartDate: Moment, timeStartValue: Moment): Moment {
  return combineMomentDateTime(moment(sessionStartDate), moment(timeStartValue));
}

export function isClientAssignmentActiveAtDateTime(
  assignment: IClientAssignment,
  sessionDateTime: Moment,
): boolean {
  return (
    moment(assignment.date_start).isSameOrBefore(sessionDateTime) &&
    (assignment.date_end === null ||
      moment(assignment.date_end).endOf('day').isAfter(sessionDateTime))
  );
}
